import { twMerge } from "tailwind-merge"

interface ContentDividerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
}

export const ContentDivider = ({
  className,
  ...props
}: ContentDividerProps) => (
  <div
    className={twMerge(
      "relative py-6 md:py-8 before:content-[''] before:block before:absolute before:h-px before:bg-neutral-700 before:w-full before:m-auto before:top-0 before:bottom-0",
      className
    )}
    {...props}
  />
)
